var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[_c('div',{staticClass:"icon"},[_c('VIcon',{attrs:{"color":_vm.iconColor,"small":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.formattedDescription))])])
}
var staticRenderFns = []

export { render, staticRenderFns }